import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isNil from "lodash/isNil";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState, { initialExperimentBackendStatus } from 'redux/reducers/backendStatus/initialState';
var workerTaskRegistered = produce(function (draft, action) {
  var _draft$experimentId, _draft$experimentId2, _draft$experimentId2$, _draft$experimentId3, _draft$experimentId3$;
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    taskName = _action$payload.taskName,
    workerGpuType = _action$payload.workerGpuType;

  // Work can be dispatched before the experiment's backend status has finished loading,
  // so create the entry rather than dropping the update on the floor.
  (_draft$experimentId = draft[experimentId]) !== null && _draft$experimentId !== void 0 ? _draft$experimentId : draft[experimentId] = _objectSpread(_objectSpread({}, initialExperimentBackendStatus), {}, {
    // Fresh maps per experiment: a shallow spread would share the module-level ones,
    // and immer freezes them once the first experiment has been produced.
    workerStatus: {},
    taskWorkers: {}
  });
  (_draft$experimentId2$ = (_draft$experimentId2 = draft[experimentId]).taskWorkers) !== null && _draft$experimentId2$ !== void 0 ? _draft$experimentId2$ : _draft$experimentId2.taskWorkers = {};
  (_draft$experimentId3$ = (_draft$experimentId3 = draft[experimentId]).workerStatus) !== null && _draft$experimentId3$ !== void 0 ? _draft$experimentId3$ : _draft$experimentId3.workerStatus = {};
  draft[experimentId].taskWorkers[taskName] = workerGpuType;
  var worker = draft[experimentId].workerStatus[workerGpuType];
  if (_isNil(worker)) {
    draft[experimentId].workerStatus[workerGpuType] = {
      statusCode: null,
      taskName: null,
      progress: null,
      userMessage: null
    };
  }
}, initialState);
export default workerTaskRegistered;